import {gsap} from "../LibrariesImport";
export default class BlockSliderScrollable {
	static init() {
		this.sliders = document.querySelectorAll(".block-slider-scrollable");

		if(!this.sliders) {
			return;
		}

		this.buildSliders();
	}

	static buildSliders() {
		this.sliders.forEach(slider => {
			const stage = slider.querySelector(".swiper-slider-scrollable");
			const drag = slider.querySelector(".swiper-scrollbar");
			const arrows = slider.querySelector(".arrows");
			// const canvas = slider.querySelector("canvas");
			const swiper = new Swiper(stage, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				spaceBetween: stage.dataset.spaceBetween ? stage.dataset.spaceBetween : "4%",
				speed: 500,
				touchEventsTarget: "container",
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				scrollbar: {
					el: drag,
					draggable: true,
					snapOnRelease: false,
				},
				on:{
					touchStart: () => {
						gsap.to(arrows, 0.2, {
							scale: 0.2
						});
					},
					touchMove: (swiper, e) => {
						let sliderOffset = slider.getBoundingClientRect();

						gsap.to(arrows, 0.3, {
							top: e.clientY - sliderOffset.top,
							left: e.clientX - sliderOffset.left
						});
					},
					touchEnd: () => {
						gsap.to(arrows, 0.2, {
							scale: 1
						});
					},
					lock: () => {
						stage.classList.remove("swiper-is-active");
					},
					unlock: () => {
						stage.classList.add("swiper-is-active");
					},
					resize: (swiper) => {
						arrows.classList.toggle("hidden", swiper.isEnd);
					}
				}
			});

			swiper.slides.forEach((slide) => {
				slide.querySelectorAll('a').forEach( (link) => {
					link.addEventListener("mouseenter", () => {
						gsap.to(arrows, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					});
					link.addEventListener("mouseleave", () => {
						gsap.to(arrows, 0.2, {
							scale: 1,
							opacity: 1
						});
					});
				});
			});

			stage.addEventListener("mouseenter", (e) => {
				let sliderOffset = slider.getBoundingClientRect();

				gsap.to(arrows, 0.2, {
					scale: 1,
				});

				gsap.set(arrows, {
					top: e.clientY - sliderOffset.top,
					left: e.clientX - sliderOffset.left,
				});
			});

			stage.addEventListener("mousemove", (e) => {
				let sliderOffset = slider.getBoundingClientRect();
				gsap.to(arrows, 0.3, {
					top: e.clientY - sliderOffset.top,
					left: e.clientX - sliderOffset.left
				});
			});

			stage.addEventListener("mouseleave", () => {
				gsap.to(arrows, 0.2, {
					scale: 0,
					overwrite: true
				});
			});
		});
	}
}